import { render, staticRenderFns } from "./PublishLinkForm.vue?vue&type=template&id=2cf0342d&scoped=true"
import script from "./PublishLinkForm.vue?vue&type=script&lang=js"
export * from "./PublishLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0342d",
  null
  
)

export default component.exports